
import { SystemMessageEntityDecorator } from './system-message.decorator';
import { SystemMessage } from './system-message.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class SystemMessageTypeInfoBase implements CrudTypeInfo<SystemMessage, number> {
  name = 'System Message';
  entityDecorator = new SystemMessageEntityDecorator();
  
  createAuthorities = ['WRITE_SYSTEM_MESSAGE'];
  editAuthorities = ['WRITE_SYSTEM_MESSAGE'];
  deleteAuthorities = ['WRITE_SYSTEM_MESSAGE'];
  viewAuthorities = ['READ_SYSTEM_MESSAGE'];
  
  searchRouteBase = ['/systemmessage/search'];
  createRouteBase = ['/systemmessage/create'];
  editRouteBase = ['/systemmessage/edit'];
  viewRouteBase = ['/systemmessage/view'];
  
  description(item: SystemMessage): string {
    return '' +  item.id;
  }
}



